function Spinner() {
  return (
    <div id="loading"></div>
  );
}

export default Spinner;